import includes from 'core-js/library/fn/array/virtual/includes';
import 'core-js/fn/symbol/iterator.js';
import 'core-js/es6';
import 'date-time-format-timezone/build/src/date-time-format-timezone-golden-zones-no-locale';
import './element-prototype-closest';

Array.prototype.includes = includes;
